/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDlvrySplitHeroBlockViewProps } from './dlvry-split-hero-block';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IDlvrySplitHeroBlockViewProps) => {
    const {
        SplitHeroBlock,
        baseClassName,
        heading,
        description,
        links,
        image
    } = props;

    return (
        <Module {...SplitHeroBlock}>
            <Node className={`${baseClassName}__content`}>
                {heading}
                {description}
                {links}
            </Node>
            <Node className={`${baseClassName}__image__container`}>
                {image}
            </Node>
        </Module>
    );
};
